import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  align-items: ${(props) => props.align || "center"};
  justify-content: ${(props) => props.justify || "flex-start"};
  gap: ${(props) => props.gap || "0"};
  flex-wrap: ${(props) => (props.$wrap ? "wrap" : "nowrap")};
`;

/**
 * Inline component for horizontal (row) layout with optional wrapping
 * @param {string} gap - Space between items (e.g., "16px", "1rem")
 * @param {string} align - Cross-axis alignment: "flex-start" | "center" | "flex-end" | "stretch"
 * @param {string} justify - Main-axis alignment: "flex-start" | "center" | "flex-end" | "space-between" | "space-around" | "space-evenly"
 * @param {boolean} wrap - Whether items should wrap to new lines
 * @param {string} as - HTML tag to render as (default: "div")
 * @param {React.ReactNode} children - Child elements
 */
function Inline({ children, gap, align, justify, wrap = false, as = "div", ...props }) {
  return (
    <Wrapper
      as={as}
      gap={gap}
      align={align}
      justify={justify}
      $wrap={wrap}
      {...props}
    >
      {children}
    </Wrapper>
  );
}

export default Inline;